import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Glyph extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    color: PropTypes.string,
    customClass: PropTypes.string,
    onClick: PropTypes.func,
    font: PropTypes.number,
    disabled: PropTypes.bool,
  }

  render() {
    const { onClick, disabled, font } = this.props

    const glyphClass = classNames(
      'glyph',
      `glyph-${this.props.type}`,
      !disabled
        ? {
            [`color-${this.props.color}`]: this.props.color,
          }
        : 'color-disabled',
      !disabled && this.props.customClass
    )

    return <i style={{fontSize: font  }} onClick={!disabled ? onClick : () => {}} className={glyphClass} />
  }
}

export default Glyph
